let videoOrientationPortrait = false;
let playerContainer = null;

document.querySelectorAll('.corusPlayer-container').forEach((player) => {
	player.addEventListener('mousedown', () => {
		const playerPortraitOrientation = player.querySelector('.jw-orientation-portrait');

		if (playerPortraitOrientation) {
			videoOrientationPortrait = true;
			playerContainer = player;
		} else {
			videoOrientationPortrait = false;
		}
	});

	player.addEventListener('click', () => {
		if (playerContainer && videoOrientationPortrait) {
			const adBlockerMessage = playerContainer.querySelector('.adBlockerMessage');
			if (adBlockerMessage) {
				adBlockerMessage.classList.add('portraitVideoAdBlocker');
			}
		}
	});
});
